/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  Button,
  DIALOG_SIZE_SM_MD,
  DialogContentProps,
  DialogProps,
  ICON_ADD_FOLDER,
  ICON_FOLDER_WITH_ADD_CIRCLE,
  SdsIcon,
} from '@squiz/sds';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { COMPONENT_SET_DETAILS_DATA_IDS } from '../../../ComponentSetDetails/ComponentSetDetails.constants';
import { CreateComponentSetForm } from '../../forms/CreateComponentSetForm';

/**
 * Component set list empty state.
 */
export const ComponentSetListEmptyState = (): JSX.Element => {
  const { t } = useTranslation();

  const labels = {
    createNewSet: t(COMPONENT_SERVICE_STRINGS.createNewSet),
    dialogTitle: t(COMPONENT_SERVICE_STRINGS.createNewComponentSet),
    noComponentSets: t(COMPONENT_SERVICE_STRINGS.noComponentSets),
    useTheButton: t(COMPONENT_SERVICE_STRINGS.useTheButtonBelow),
  };

  const { updateActiveDialog } = useDialogStore();

  // The dialog props for the CreateComponentSetForm.
  const dialogProps: DialogProps = {
    dialogContent: {
      renderContent: (props: DialogContentProps): JSX.Element => {
        return <CreateComponentSetForm {...props} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM_MD,
    heading: labels.dialogTitle,
    showDividers: true,
    stateHandler: useDialogStore,
  };

  const openDialog = (): void => {
    updateActiveDialog(dialogProps);
  };

  return (
    <div className="component-sets__list-container-empty-state">
      <div className="component-sets__list-icon" data-id={COMPONENT_SET_DETAILS_DATA_IDS.emptyStateIcon}>
        <SdsIcon svg={ICON_FOLDER_WITH_ADD_CIRCLE} />
      </div>

      <div className="component-sets__list-content">
        <h4 className="component-sets__list-content-title">{labels.noComponentSets}</h4>
        <span className="component-sets__list-content-desc ">
          {labels.useTheButton} <strong>{labels.createNewSet}</strong>
        </span>
      </div>

      <div className="component-sets__list-button">
        <Button
          data-testid={COMPONENT_SET_DETAILS_DATA_IDS.createComponentSetDialogButton}
          icon={ICON_ADD_FOLDER}
          onClick={(): void => openDialog()}
          text={labels.createNewSet}
        />
      </div>
    </div>
  );
};
